export default "__VITE_ASSET__Dko0mWZ9__"